// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-search-conditions-pop .show-search-conditions-tags {
  display: -webkit-inline-flex;
  display: inline-flex;
  overflow: hidden;
  max-width: 320px;
  min-width: 40px;
  text-align: left;
  word-break: break-all;
  margin: 4px 4px;
  color: #666;
  border-color: #DBE0E5;
  background-color: transparent;
  border-radius: 3px;
}
.show-search-conditions-pop .show-search-conditions-tags .wui-tag-text {
  -webkit-flex-shrink: 1;
          flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.show-search-conditions-pop .show-search-conditions-tags .uf-close {
  color: #ADB4BC;
}
.hw-borad-container {
  -webkit-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background: #fff;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}
.hw-borad-container .lne-wdth-drp {
  position: absolute;
  width: 70px;
  list-style: none;
  z-index: 10000;
  left: 0;
  top: 0;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 0 6px 1px #ccc;
  padding: 0;
  margin: 0;
}
.hw-borad-container .lne-wdth-drp > li {
  background-color: #000;
  box-sizing: content-box;
  border: 10px solid #fff;
  cursor: pointer;
}
.hw-borad-container .lne-wdth-drp > li.active,
.hw-borad-container .lne-wdth-drp > li:hover {
  border-color: #eee;
}
.hw-borad-container .tip {
  font-size: 40px;
  color: #bfbfbf;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
          transform: translate3d(-50%, -50%, 0);
}
.hw-borad-container .canvas-wrapper {
  margin-left: -20px;
  margin-right: -20px;
  cursor: default;
  position: relative;
}
.hw-borad-container.fix {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: auto!important;
  height: auto!important;
  box-sizing: border-box;
  padding-top: 50px;
}
.hw-borad-container.fix .actions {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  box-shadow: 0 0 5px 3px #ccc;
  margin-top: 0;
  padding: 10px 10px 25px;
  background: #fff;
  overflow: hidden;
  transition: position 300ms;
}
.hw-borad-container.fix .actions .btn-folder {
  position: absolute;
  left: 50%;
  bottom: 0;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  background: transparent;
}
.hw-borad-container.fix .actions .btn-folder.expand {
  -webkit-transform: translateX(-50%) rotateZ(180deg);
          transform: translateX(-50%) rotateZ(180deg);
  bottom: 25px;
}
.hw-borad-container.fix .actions .btn-folder:before,
.hw-borad-container.fix .actions .btn-folder:after {
  content: '';
  display: block;
  border-style: solid;
  border-color: transparent;
  border-width: 10px;
  position: absolute;
  bottom: -5px;
  left: 50%;
  cursor: pointer;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}
.hw-borad-container.fix .actions .btn-folder:before {
  border-top-color: #3B70CE;
}
.hw-borad-container.fix .actions .btn-folder:after {
  border-top-color: #fff;
  bottom: -3px;
}
.hw-borad-container.fix.hide-btns .actions {
  top: -40px;
  box-shadow: none;
}
.hw-borad-container.fix .close {
  top: 15px;
  right: 20px;
  position: absolute;
  z-index: 200;
}
.hw-borad-container.fix .canvas-wrapper {
  margin-left: 0;
  margin-right: 0;
  margin-top: -25px;
  position: relative;
}
.hw-borad-container.fix .canvas-wrapper,
.hw-borad-container.fix .canvas-wrapper canvas {
  width: 100%;
  height: 100%;
}
.hw-borad-container.fix .canvas-wrapper canvas {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
.hw-borad-container.flex .actions {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
          flex-direction: row;
  -webkit-justify-content: space-around;
          justify-content: space-around;
}
.hw-borad-container.flex .actions a {
  margin-bottom: 0;
}
.hw-borad-container .actions {
  overflow: auto;
  margin-top: 30px;
}
.hw-borad-container .actions a {
  background: #e0e0e0;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  width: 80px;
  display: block;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 12px;
}
.hw-borad-container .actions a[data-action="colorSet"] {
  color: #fff;
}
.hw-borad-container .actions [data-action="colorSet"] {
  background: #000000;
}
.hw-borad-container .actions [data-action="redo"],
.hw-borad-container .actions [data-action="undo"] {
  cursor: not-allowed;
  color: #ccc;
}
.hw-borad-container .actions [data-action="clear"].active,
.hw-borad-container .actions [data-action="redo"].active,
.hw-borad-container .actions [data-action="undo"].active,
.hw-borad-container .actions a[data-action="save"] {
  cursor: pointer;
  background-color: #E4E4E4;
  color: #555555;
}
.hw-borad-container .close {
  color: #333;
  float: right;
  font-size: 24px;
  line-height: 15px;
  -webkit-transform: rotateZ(-45deg);
          transform: rotateZ(-45deg);
  cursor: pointer;
}
.hw-borad-container canvas {
  background: transparent;
  border: 1px dashed #D0D0D0;
  margin-top: 15px;
  cursor: crosshair;
  position: relative;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/index.less","webpack://./src/components/HandWrittenSignature/HandWritingBoard/index.less"],"names":[],"mappings":"AAOA;EAEI,4BAAA;EAAA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;ACPJ;ADLA;EAeM,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACPN;ADXA;EAsBM,cAAA;ACRN;AAlBA;EAgCE,yBAAA;MAAA,qBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAXF;AAzBA;EAEI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,SAAA;AA0BJ;AAtCA;EAcM,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AA2BN;AA1BM;;EAEE,kBAAA;AA4BR;AAhDA;EAyBI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6CAAA;UAAA,qCAAA;AA0BJ;AAxDA;EAsCI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAqBJ;AAnBE;EACE,eAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AAqBJ;AA/BE;EAYI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;AAsBN;AA5CE;EAwBM,kBAAA;EACA,SAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,uBAAA;AAuBR;AAtBQ;EACE,mDAAA;UAAA,2CAAA;EACA,YAAA;AAwBV;AAtBQ;;EAEE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,mCAAA;UAAA,2BAAA;AAwBV;AAtBQ;EACE,yBAAA;AAwBV;AAtBQ;EACE,sBAAA;EACA,YAAA;AAwBV;AApBI;EAEI,UAAA;EACA,gBAAA;AAqBR;AA/EE;EA8DI,SAAA;EACA,WAAA;EAEA,kBAAA;EACA,YAAA;AAmBN;AArFE;EAqEI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAmBN;AAlBM;;EAEE,WAAA;EACA,YAAA;AAoBR;AAhGE;EA+EM,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AAoBR;AAhBE;EAEI,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,qCAAA;UAAA,6BAAA;AAiBN;AArBE;EAMM,gBAAA;AAkBR;AAzJA;EA4II,cAAA;EACA,gBAAA;AAgBJ;AA7JA;EA+IM,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAiBN;AAhBM;EACE,WAAA;AAkBR;AA5KA;EA8JM,mBAAA;AAiBN;AA/KA;;EAkKM,mBAAA;EACA,WAAA;AAiBN;AApLA;;;;EAyKM,eAAA;EACA,yBAAA;EACA,cAAA;AAiBN;AA5LA;EA+KM,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;UAAA,0BAAA;EACA,eAAA;AAgBN;AApMA;EAuLM,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAgBN","sourcesContent":["// 样式变量定义\n// @theme: #f53c32;\n\n// 公共样式\n// body{\n//     background-color: #ffffff;\n// }\n.show-search-conditions-pop {\n  .show-search-conditions-tags {\n    display: inline-flex;\n    overflow: hidden;\n    max-width: 320px;\n    min-width: 40px;\n    text-align: left;\n    word-break: break-all;\n    margin: 4px 4px;\n    color: #666;\n    border-color: #DBE0E5;\n    background-color: transparent;\n    border-radius: 3px;\n\n    .wui-tag-text {\n      flex-shrink: 1;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    .uf-close {\n      color: #ADB4BC;\n    }\n  }\n}","@import '../../../assets/style/index.less';\n\n// $color-danger: #E14C46 !default;\n.hw-borad-container{\n  .lne-wdth-drp{\n    position: absolute;\n    width: 70px;\n    list-style: none;\n    z-index: 10000;\n    left: 0;\n    top: 0;\n    background: #fff;\n    border-radius: 2px;\n    box-shadow: 0 0 6px 1px #ccc;\n    padding: 0;\n    margin: 0;\n    > li{\n      background-color: #000;\n      box-sizing: content-box;\n      border: 10px solid #fff;\n      cursor: pointer;\n      &.active,\n      &:hover{\n        border-color: #eee;\n      }\n    }\n  }\n  .tip{\n    font-size: 40px;\n    color: #bfbfbf;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0)\n  }\n  user-select: none;\n  background: #fff;\n  text-align: center;\n  padding: 20px;\n  box-sizing: border-box;\n  .canvas-wrapper{\n    margin-left: -20px;\n    margin-right: -20px;\n    cursor: default;\n    position: relative;\n  }\n  &.fix{\n    position: fixed;\n    z-index: 1000;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    width: auto!important;\n    height: auto!important;\n    box-sizing: border-box;\n    padding-top: 50px;\n    .actions{\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      z-index: 100;\n      box-shadow: 0 0 5px 3px #ccc;\n      margin-top: 0;\n      padding: 10px 10px 25px;\n      background: #fff;\n      overflow: hidden;\n      transition: position 300ms;\n      .btn-folder{\n        position: absolute;\n        left: 50%;\n        bottom: 0;\n        transform: translateX(-50%);\n        background: transparent;\n        &.expand{\n          transform: translateX(-50%) rotateZ(180deg);\n          bottom: 25px;\n        }\n        &:before,\n        &:after{\n          content: '';\n          display: block;\n          border-style: solid;\n          border-color: transparent;\n          border-width: 10px;\n          position: absolute;\n          bottom: -5px;\n          left: 50%;\n          cursor: pointer;\n          transform: translateX(-50%);\n        }\n        &:before{\n          border-top-color: #3B70CE;\n        }\n        &:after{\n          border-top-color: #fff;\n          bottom: -3px;\n        }\n      }\n    }\n    &.hide-btns{\n      .actions{\n        top: -40px;\n        box-shadow: none;\n      }\n    }\n    .close{\n      top: 15px;\n      right: 20px;\n      z-index: 200;\n      position: absolute;\n      z-index: 200;\n    }\n    .canvas-wrapper{\n      margin-left: 0;\n      margin-right: 0;\n      margin-top: -25px;\n      position: relative;\n      &,\n      canvas{\n        width: 100%;\n        height: 100%;\n      }\n      canvas{\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n      }\n    }\n  }\n  &.flex{\n    .actions{\n      display: flex;\n      flex-direction: row;\n      justify-content: space-around;\n      a{\n        margin-bottom: 0;\n      }\n    }\n  }\n  .actions{\n    overflow: auto;\n    margin-top: 30px;\n    a{\n      background: #e0e0e0;\n      text-align: center;\n      height: 30px;\n      line-height: 30px;\n      border-radius: 5px;\n      width: 80px;\n      display: block;\n      margin-bottom: 15px;\n      cursor: pointer;\n      font-size: 12px;\n      &[data-action=\"colorSet\"]{\n        color: #fff;\n      }\n    }\n    [data-action=\"colorSet\"]{\n      background: rgba(0, 0, 0, 1);\n    }\n    [data-action=\"redo\"],\n    [data-action=\"undo\"]{\n      cursor: not-allowed;\n      color: #ccc;\n    }\n    [data-action=\"clear\"].active,\n    [data-action=\"redo\"].active,\n    [data-action=\"undo\"].active,\n    a[data-action=\"save\"]{\n      cursor: pointer;\n      background-color: #E4E4E4;\n      color: #555555;\n    }\n  }\n  .close{\n      color: #333;\n      float: right;\n      font-size: 24px;\n      line-height: 15px;\n      transform: rotateZ(-45deg);\n      cursor: pointer;\n  }\n  canvas{\n      background: transparent;\n      border: 1px dashed #D0D0D0;\n      margin-top: 15px;\n      cursor: crosshair;\n      position: relative;\n      z-index: 10;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
